import {
  ActiveVaultMethod,
  AddCexMethod,
  BalancesMethod,
  CanByPassApprovalTradeHubMethod,
  CancelOrderMethod,
  CheckAddressIsWhitelistedMethod,
  ConnectMethod,
  CreateOrderMethod,
  DepositMethod,
  DepositableTokensMethod,
  DisconnectMethod,
  EditOrderMethod,
  FetchPartnersMethod,
  FocusTabMethod,
  GetAddressBookMethod,
  GetConfigMethod,
  GetCurrentAppTab,
  GetEnvironmentMethod,
  GetMarketRateMethod,
  GetMinAmountsMethod,
  GetNetworksMethod,
  GetOHLCVMethod,
  GetPricesMethod,
  GetSettingsMethod,
  GetSupportedTokensMethod,
  GetTokenNamesAndSymbolsMethod,
  GetTradePathBySupportedTokensMethod,
  GetTradePathMethod,
  GetUserIdMethod,
  GetExchangeUserIdMethod,
  GetWhitelistedAddressesMethod,
  GetWidgetBundleUrlMethod,
  GetWithdrawalByIdMethod,
  IsWalletTypeTotupNeededMethod,
  MarketPairsMethod,
  NftsMethod,
  OpenOrdersMethod,
  OpenPageWithHelperMethod,
  OpenTabMethod,
  PrepareOrderMethod,
  PrepareWithdrawalMethod,
  RetrieveOrderMethod,
  SearchTransactionMethod,
  SetByPassApprovalTradeHubMethod,
  SupportedExchangesMethod,
  TrackLinkMethod,
  TransactionsMethod,
  UntrackLinkMethod,
  VaultAccountsMethod,
  VaultsMethod,
  VerifyKYCMethod,
  WithdrawToDefiMethod,
  WithdrawableTokensMethod,
  VerifyOrderMethod,
} from "./methods";

export interface UntrustedApi {
  connect: ConnectMethod;
  disconnect: DisconnectMethod;
  vaults: VaultsMethod;
  vaultAccounts: VaultAccountsMethod;
  supportedExchanges: SupportedExchangesMethod;
  getWithdrawalById: GetWithdrawalByIdMethod;
  transactions: TransactionsMethod;
  balances: BalancesMethod;
  nfts: NftsMethod;
  openOrders: OpenOrdersMethod;
  retrieveOrder: RetrieveOrderMethod;
  editOrder: EditOrderMethod;
  getMinAmounts: GetMinAmountsMethod;
  createOrder: CreateOrderMethod;
  prepareOrder: PrepareOrderMethod;
  getMarketPairs: MarketPairsMethod;
  getMarketRate: GetMarketRateMethod;
  activeVault: ActiveVaultMethod;
  depositableTokens: DepositableTokensMethod;
  getNetworks: GetNetworksMethod;
  deposit: DepositMethod;
  cancelOrder: CancelOrderMethod;
  addCex: AddCexMethod;
  withdrawToDefi: WithdrawToDefiMethod;
  prepareWithdrawal: PrepareWithdrawalMethod;
  verifyOrder: VerifyOrderMethod;
  withdrawableTokens: WithdrawableTokensMethod;
  getPrices: GetPricesMethod;
  getSettings: GetSettingsMethod;
  getEnvironment: GetEnvironmentMethod;
  getAddressBook: GetAddressBookMethod;
  checkAddressIsWhitelisted: CheckAddressIsWhitelistedMethod;
  searchTransaction: SearchTransactionMethod;
  getWidgetBundleUrl: GetWidgetBundleUrlMethod;
  getWhitelistedAddresses: GetWhitelistedAddressesMethod;
  getTradePath: GetTradePathMethod;
  getSupportedTokens: GetSupportedTokensMethod;
  isWalletTypeTotupNeeded: IsWalletTypeTotupNeededMethod;
  trackLink: TrackLinkMethod;
  openPageWithHelper: OpenPageWithHelperMethod;
  untrackLink: UntrackLinkMethod;
  getConfig: GetConfigMethod;
  fetchPartners: FetchPartnersMethod;
  getCurrentAppTab: GetCurrentAppTab;
  focusTab: FocusTabMethod;
  getUserId: GetUserIdMethod;
  getTradePathBySupportedTokens: GetTradePathBySupportedTokensMethod;
  verifyKYC: VerifyKYCMethod;
  getTokenNamesAndSymbols: GetTokenNamesAndSymbolsMethod;
  getOHLCV: GetOHLCVMethod;
  openTab: OpenTabMethod;
  canByPassApprovalTradeHub: CanByPassApprovalTradeHubMethod;
  setByPassApprovalTradeHub: SetByPassApprovalTradeHubMethod;
  getExchangeUserId: GetExchangeUserIdMethod;
}

export type UntrustedApiMethods = keyof UntrustedApi;

export type UntrustedApiParams = {
  [key in UntrustedApiMethods]: Parameters<UntrustedApi[key]>[0];
};
export type UntrustedApiReturn = {
  [key in UntrustedApiMethods]: Awaited<ReturnType<UntrustedApi[key]>>;
};

export type RequestArguments<K extends UntrustedApiMethods> = UntrustedApiParams[K] extends undefined
  ? { method: K }
  : undefined extends UntrustedApiParams[K]
    ? { method: K; params?: UntrustedApiParams[K] }
    : { method: K; params: UntrustedApiParams[K] };
